var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navi-blog-post",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.333,
    height: 20,
    viewBox: "0 0 18.333 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M120.835,2.292A2.291,2.291,0,0,0,118.543,0H108.96a2.291,2.291,0,0,0-2.292,2.292v11.25a2.291,2.291,0,0,0,2.292,2.292h9.583a2.291,2.291,0,0,0,2.292-2.292Zm-3.958,9.792h-6.25a.625.625,0,1,1,0-1.25h6.25a.625.625,0,0,1,0,1.25Zm0-2.5h-6.25a.625.625,0,1,1,0-1.25h6.25a.625.625,0,0,1,0,1.25Zm0-2.5h-6.25a.625.625,0,1,1,0-1.25h6.25a.625.625,0,0,1,0,1.25Zm0,0",
    transform: "translate(-102.501)",
    fill: "#d6d6d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M6.458,68.332A3.545,3.545,0,0,1,2.917,64.79V53.54c0-.072.017-.138.021-.208H2.292A2.294,2.294,0,0,0,0,55.624V68.957a2.294,2.294,0,0,0,2.292,2.292h10a2.293,2.293,0,0,0,2.292-2.292v-.625Zm0,0",
    transform: "translate(0 -51.249)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.f4e4acc1656210bc1b4a6b9d5497fba2.svg";
export { ForwardRef as ReactComponent };